import { Button } from '@folio/components';

export function ToggleGroup<T extends string>({
  label,
  options,
  value,
  onChange,
  optionLabel,
}: {
  label: string;
  options: T[];
  value: T;
  onChange: (value: T) => void;
  optionLabel: (option: T) => string;
}) {
  return (
    <div role="group" aria-label={label} className="inline-flex rounded-md border bg-card p-0.5">
      {options.map(option => (
        <Button
          key={option}
          size="xs"
          variant={option === value ? 'secondary' : 'ghost'}
          aria-pressed={option === value}
          onClick={() => onChange(option)}
        >
          {optionLabel(option)}
        </Button>
      ))}
    </div>
  );
}
